<template lang="html">
  <div>
    <b-row class="mt-5">
      <b-col class="mt-3">
        <b-img
          :src="require('./timeline.png')"
          thumbnail
          class="timeline-thumb float-left"
        />
        <b-btn
          size="md"
          variant="primary"
          class="float-left ml-3 mt-2"
          @click="$store.dispatch('show/openInEditor')"
        >
          Open in Timeline Editor <v-icon name="magic" />
        </b-btn>
      </b-col>
    </b-row>
    <p class="smaller-1 mt-3 mb-4">
      Fine tune image timings with the Timeline Editor.
    </p>
    <div>
      <hr class="mr-5" />
      <p class="smaller-1 mt-4">
        This show uses exact timings.
        <br />
        Even spacing is disabled.
      </p>
      <p>
        <b-btn size="sm" variant="outline-danger" @click="confirmSpacingRevert">
          Revert to even-spaced mode
        </b-btn>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowTimelineSetup",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    confirmSpacingRevert() {
      var _v = this;
      this.$bvModal
        .msgBoxConfirm(
          "This action will revert your show to evenly-spaced mode, and discard your timeline edits." +
            " Your image order will revert back to your original selected sort-order.",
          {
            title: "Revert to evenly-spaced mode?",
            okTitle: "Yes",
          }
        )
        .then((value) => {
          console.log("confirm", value);
          if (value === true) {
            _v.$store.dispatch("show/resetCurrentShowToEvenTimeline");
          }
        })
        .catch((err) => {
          // An error occurred
          throw err;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.smaller-1 {
  font-size: 0.84em;
}
.timeline-thumb {
  max-height: 60px;
}
</style>
